import styled from "styled-components";

export const StyledTitleGradientCard = styled.div`
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 4px 10px 0px #7e8aad40;
  margin-bottom: 30px;
  background: linear-gradient(271.58deg, #004ef7 0%, #00eab2 96.51%);

  .title-gradient-inner {
    padding: 14px 24px;
    min-height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  .title-gradient-text {
    margin: 0;
    font-family: "Noto Sans Hebrew", sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: -0.22px;
    text-align: center;
    color: #ffffff;
    word-break: break-word;
  }
`;
